import React, {Component} from 'react'

import Dialog from '@material-ui/core/Dialog'
import DialogTitle from '@material-ui/core/DialogTitle'
import DialogContent from '@material-ui/core/DialogContent'
import DialogActions from '@material-ui/core/DialogActions'

import Button from '@material-ui/core/Button'

/**
 * attachment
 * 
 * onRemoveClick(attachment)
 * onCancelClick
 */

class RemoveAttachmentDialog extends Component {

	render() {

		return <Dialog
			open = {true}
			scroll = "body"
		>

			<DialogTitle>
				Удалить предмет
			</DialogTitle>

			<DialogContent style = {{display: "flex", flexDirection: "column"}}>
				Вы уверены, что хотите удалить предмет &laquo;{this.props.attachment.item.name}&raquo;?
			</DialogContent>

			<DialogActions>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onRemoveClick === "function") {
							this.props.onRemoveClick(this.props.attachment)
						}
					}}
				>Удалить</Button>

				<Button
					onClick = {e => {
						e.stopPropagation()
						if (typeof this.props.onCancelClick === "function") {
							this.props.onCancelClick()
						}
					}}
				>Отмена</Button>

			</DialogActions>

		</Dialog>

	}

}

export default RemoveAttachmentDialog
